import React from 'react';
import styled from 'styled-components';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ResetPasswordFormValues } from '../common/interfaces';
import { ResetPasswordForm } from './resetPasswordForm';
import { ErrorTypography } from '../common/errorTypography';

interface ResetPasswordViewProps {
    submitResetPassword: (data: ResetPasswordFormValues) => void;
    fieldsErrors: FieldErrors;
    handleSubmit: UseFormMethods['handleSubmit'];
    register: UseFormMethods['register'];
    loading: boolean;
    serverError?: string;
}

export const ResetPasswordView = ({ 
    submitResetPassword,  
    fieldsErrors, 
    handleSubmit, 
    register,
    loading,
    serverError
}: ResetPasswordViewProps) => {
    const { t } = useTranslation();

    return (
        <StyledContainer>
            <Grid container spacing={2}>
                <Grid 
                    container 
                    item 
                    xs={12}
                >
                    <TitleTypography>
                        {t('passwordRecovery')}
                    </TitleTypography>
                </Grid>
                <ResetPasswordForm 
                    submitResetPassword={submitResetPassword}
                    fieldsErrors={fieldsErrors}
                    handleSubmit={handleSubmit}
                    register={register}
                    loading={loading}
                />
                {serverError
                    && <Grid container item xs={12}>
                        <ErrorTypography serverError={serverError} />
                    </Grid>
                }
                <Grid 
                    container 
                    item 
                    xs={12}
                >
                    <RememberedPasswordTypography>
                        {t('rememberedPassword')}
                    </RememberedPasswordTypography>
                </Grid>
                <Grid container item xs={12}>
                    <GoToSignInButton 
                        onClick={() => {history.back();}}
                        fullWidth
                        variant='outlined'
                        disableElevation
                    >
                        {t('signIn')}
                    </GoToSignInButton>
                </Grid>
            </Grid>
        </StyledContainer>
    );
};

const StyledContainer = styled(Container)`
    margin-top: 40px;
    font: Roboto;
    font-size: 15px;
    font-weight: 400;
    font-style: normal;
    font-family: sans-serif;
`;

const TitleTypography = styled(Typography)`
    color: #555555;
`;

const RememberedPasswordTypography = styled(Typography)`
    color: #888888;
    font-size: 15px;
    margin: 80px auto 0 auto;
`;

const GoToSignInButton = styled(Button)`
    background-color: #ffffff;
`;
